export const BASE_URL = (version = 'v1') =>
  `${process.env.REACT_APP_API_URL}${version}`;

export const GRAPHQL_BASE_URL = () =>
  `${process.env.REACT_APP_SERVICE_TYPE}` === 'T'
    ? 'https://bff.dev.doctornow.co.kr/graphql'
    : '//bff.doctornow.co.kr/graphql';

//Utils
export const VERIFICATIONS_TOKEN = '/verifications';
